export function isTechnicalOfficeType(type?: string | null): boolean {
  return (type ?? '').toLowerCase() === 'technicaloffice';
}

export function isCommunityType(type?: string | null): boolean {
  return (type ?? '').toLowerCase() === 'community';
}

export function isCompanyType(type?: string | null): boolean {
  return (type ?? '').toLowerCase() === 'company';
}
